import { useEffect, useState } from "react";
import { Toaster } from "react-hot-toast";
import IconButton from "../../../../../components/IconButton";
import Spinner from "../../../../../components/Spinner";
import { toastError } from "../../../../../components/Toast";
import useAuthData from "../../../../../hook/useAppData";
import { IconLeftArrowVersion2 } from "../../../../../icons";
import { _formatDate } from "../../../../../libs/dateUtils";
import { postEletronic, putEletronic } from "../service";
import { FormInputRows } from "./components/FormInputRows";
import { generateObject, tratamentObject } from "./libs/generateObject";
import { getInventoryEletronicById, getUsers } from "./libs/reqs";
import { EletronicInventoryStoreProvider } from "./store";
import useEletronicInventoryStore from "./store/useStore";
import "./index.scss";

export function FormInventoryEletronics(props?: any) {
  const params = props.match.params?.id;

  return (
    <EletronicInventoryStoreProvider>
      <InventoryEletronicsForm params={params} />
    </EletronicInventoryStoreProvider>
  );
}

function InventoryEletronicsForm(props?: any) {
  const { token } = useAuthData();
  const { defaultValues, createOrUpdate, needSpinner, state, listUsers, file } = useEletronicInventoryStore();
  const { setDefaultValues, setCreateOrUpdate, setNeedSpinner, setState, setListUsers, setFile } = useEletronicInventoryStore();
  const { handleExitClick } = useEletronicInventoryStore();

  const params = props.params;

  useEffect(() => {
    getUsers(setListUsers, token);
    if (params) {
      setNeedSpinner(true);
      setCreateOrUpdate("update");
      getInventoryEletronicById(token, params, setCreateOrUpdate, setNeedSpinner, setState, setDefaultValues, setFile);
    }
  }, []);

  useEffect(() => {
    setNeedSpinner(true);
    setTimeout(() => {
      setNeedSpinner(false);
    }, 1000);
  }, [listUsers]);

  async function handleSubmitForm(event: any) {
    event.preventDefault();
    const obj = generateObject(defaultValues, state);
    const tratamentObj = tratamentObject(obj);
    saveData(tratamentObj);
  }

  function saveData(tratamentObj) {
    const isPost = createOrUpdate === "create";

    if (isPost) return postEletronicSubmit(tratamentObj);
    return putEletronicSubmit(tratamentObj);
  }

  async function postEletronicSubmit(data) {
    const res = await postEletronic({ data, file }, token);
    verefyIfReturnIsOk(res);
  }

  async function putEletronicSubmit(data) {
    const res = await putEletronic({ data, file }, token, params);
    verefyIfReturnIsOk(res);
  }

  function verefyIfReturnIsOk(res) {
    if (res?.ok) return handleExitClick();
    return toastError("Nao foi possível realizar essa ação, verifique e tente novamente!");
  }

  return (
    <>
      <Toaster />
      <div className="container eletronic-inventory-div">
        <div className="form-box-title title-form header-eletronic-form">
          <IconButton onClick={handleExitClick} className="title-arrow pointer" icon={IconLeftArrowVersion2} />
          <h1 className="row ">
            {createOrUpdate == "create" ? "Adicionar Novo" : "Atualizar"} Item {defaultValues?.nameProduct && "- " + defaultValues?.nameProduct}{" "}
          </h1>
        </div>
        <Spinner status={needSpinner}>
          <FormInputRows handleSubmitForm={handleSubmitForm} />
        </Spinner>
      </div>
    </>
  );
}
